export default "<p>Signing in...</p>\r\n";